import { render } from "./WhatsNewOrb.vue?vue&type=template&id=bde498a0&scoped=true"
import script from "./WhatsNewOrb.vue?vue&type=script&lang=js"
export * from "./WhatsNewOrb.vue?vue&type=script&lang=js"

import "./WhatsNewOrb.vue?vue&type=style&index=0&id=bde498a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde498a0"]])

export default __exports__